import { FeatureFlagName, useFeatureFlag } from '@ui/providers/FeatureFlagProvider'

import { AllPipelines } from './AllPipelines'
import { AllPipelines_REST } from './AllPipelines_REST'

export const AllPipelinesWrapper = () => {
  const isQueryRailsLive = useFeatureFlag(FeatureFlagName.QueryRailsLive)

  return isQueryRailsLive ? <AllPipelines_REST /> : <AllPipelines />
}
